import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Card = styled(motion.div)`
  position: relative;
  aspect-ratio: 520/600;
  font-family: var(--font-secondary);
  border-radius: 4rem 0 4rem 0;
  margin: 0 auto 5rem;
  overflow: hidden;
  transform-origin: top;
  width: 100%;
  pointer-events: all;

  @media (${({ theme }) => theme.respondTo.desktop}) {
    position: sticky;
    max-width: ${({ index }) => `${60 + 5 * index}rem`};
    top: ${({ distanceWhenSticky }) => `${distanceWhenSticky}px`};
    border-radius: 15rem 15rem 15rem 0;
  }

  @media (${({ theme }) => theme.respondTo.desktopXXL}) {
    border-radius: 20rem 20rem 20rem 0;
  }

  &:last-child {
    display: none;
    visibility: hidden;
    @media (${({ theme }) => theme.respondTo.desktop}) {
      display: block;
    }
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.159) 30.73%,
      rgba(0, 0, 0, 0.3) 48.96%,
      rgba(0, 0, 0, 0.159) 86.98%
    );
    pointer-events: none;
    z-index: -1;
  }

  .image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  width: 100%;
  padding: 0 2rem;
  color: white;

  @media (${({ theme }) => theme.respondTo.desktop}) {
    padding: 0 9rem;
  }

  a {
    position: absolute;
    bottom: 5rem;
    font-family: var(--font-primary);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-semibold);
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 6px;
    z-index: 1;

    @media (${({ theme }) => theme.respondTo.desktop}) {
      bottom: 10rem;
    }

    &.clickable-overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 0;
      bottom: 0;
    }
  }
`;
export const Title = styled.h2`
  font-size: 4.2rem;
  font-weight: var(--font-weight-regular);
  line-height: 1.1;

  @media (${({ theme }) => theme.respondTo.desktopXL}) {
    font-size: 8rem;
  }
`;
